import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from './global-environment';

// Assistant 介面定義
export interface Assistant {
  assistantNo: string;
  title: string;
  content: string;
  imageurl: string;
  memo: string;
  enable?: boolean;
  assistantid?: string;
  vector_store_id?: string;
  tools?: string[];
  assistant_text?: string;
  assistant_bg_color?: string;
  assistant_font_color?: string;
  Initialized?: {
    init_image: string;
    init_word: string;
    init_meun: InitMenu[];
    chatavator: string;
  };
}

export interface InitMenu {
  title: string;
  content: string;
  id: string;
  enable: boolean;
  functionname?: string;
}

// 客戶設定檔相關介面
export interface CustomerConfig {
  companyid: string;
  departments: any;
  lobby: LobbyAssistant[];
  assistantCount: number;
  show_nopermission: boolean;
}

export interface LobbyAssistant {
  assistantNo: string;
  dep_id: string;
  title: string;
  content: string;
  imageurl: string;
  memo: string;
  enable: boolean;
  assistant_text?: string;
  assistant_bg_color?: string;
  assistant_font_color?: string;
}

export interface CustomerConfigResponse {
  success: boolean;
  data: CustomerConfig;
  message?: string;
}

// API 回應介面
export interface AssistantApiResponse {
  success: boolean;
  data: Assistant;
  message?: string;
}

export interface AssistantUpdateResponse {
  success: boolean;
  data: Assistant & {
    updatedAt?: string;
  };
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AssistantService {
  private apiUrl = environment.apiUrl;
  private companyid = environment.companyid;

  constructor(private http: HttpClient) {}

  /**
   * 取得 AI 助手資訊
   * @param assistantNo 助手編號
   * @returns Observable<AssistantApiResponse>
   */
  getAssistantInfo(assistantNo: string): Observable<AssistantApiResponse> {
    return this.http.get<AssistantApiResponse>(`${this.apiUrl}/api/modules/info`, {
      params: {
        companyid: this.companyid,
        assistantNo: assistantNo
      }
    }).pipe(
      catchError(error => {
        console.error('取得助手資訊失敗:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * 更新 AI 助手資訊
   * @param assistantNo 助手編號
   * @param assistantData 要更新的助手資料
   * @returns Observable<AssistantUpdateResponse>
   */
  updateAssistantInfo(assistantNo: string, assistantData: Partial<Assistant>): Observable<AssistantUpdateResponse> {
    const updateData = {
      companyid: this.companyid,
      assistantNo: assistantNo,
      ...assistantData
    };

    return this.http.put<AssistantUpdateResponse>(`${this.apiUrl}/api/modules/info`, updateData).pipe(
      catchError(error => {
        console.error('更新助手資訊失敗:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * 取得客戶設定檔
   * @returns Observable<CustomerConfigResponse>
   */
  getCustomerConfig(): Observable<CustomerConfigResponse> {
    return this.http.get<CustomerConfigResponse>(`${this.apiUrl}/api/modules/getCustomerConfig`, {
      params: {
        companyid: this.companyid
      }
    }).pipe(
      catchError(error => {
        console.error('取得客戶設定檔失敗:', error);
        return throwError(() => error);
      })
    );
  }
}